/**
 * 빌드 관련 상수들의 집합
 */

import { OS_TYPES } from './os-types.enum'
import { CPU_ARCHITECTURE_TYPES } from './cpu-architecture-types.enum'

/**
 * 빌드타입이 지정된 enum 객체
 * @ignore
 * @enum
 */
const BUILD_TYPES = Object.freeze({
    [OS_TYPES.WINDOWS]: {
        [CPU_ARCHITECTURE_TYPES.X86_64]: 'x86_64-pc-windows-msvc',
        [CPU_ARCHITECTURE_TYPES.i686]: 'i686-pc-windows-msvc',
    }
})


/**
 * OS Type과 CPU Architecture ENUM을 통해 빌드 태그 정보를 가져올 수 있습니다.
 * @example
 * getBuildTag(OS_TYPES.WINDOWS, CPU_ARCHITECTURE_TYPES.X86_64);
 * // "x86_64-pc-windows-msvc"
 * @param {OS_TYPES} osType
 * @param {CPU_ARCHITECTURE_TYPES} cpuArchitectureType
 * @return {String} 
 */
export const getBuildTag = (osType, cpuArchitectureType) => {
    return BUILD_TYPES[osType][cpuArchitectureType]
}

/**
 * getBuildTag
 */
export default getBuildTag